/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Custom_Hex_CodeInputs */

const en_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Custom Hex Code`)
};

const es_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código Hex personalizado`)
};

const fr_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Code Hex personnalisé`)
};

const de_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Benutzerdefinierter Hex-Code`)
};

const ja_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`カスタムHEXコード`)
};

const zh_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自定义 Hex 代码`)
};

const ar_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`كود لوني مخصص (Hex)`)
};

const id_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kode Hex Kustom`)
};

const it_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Codice Hex Personalizzato`)
};

const ru_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Пользовательский HEX-код`)
};

const pt_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Código Hex Personalizado`)
};

const ko_custom_hex_code = /** @type {(inputs: Custom_Hex_CodeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`맞춤형 Hex 코드`)
};

/**
* | output |
* | --- |
* | "Custom Hex Code" |
*
* @param {Custom_Hex_CodeInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const custom_hex_code = /** @type {((inputs?: Custom_Hex_CodeInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Custom_Hex_CodeInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_custom_hex_code(inputs)
	if (locale === "es") return es_custom_hex_code(inputs)
	if (locale === "fr") return fr_custom_hex_code(inputs)
	if (locale === "de") return de_custom_hex_code(inputs)
	if (locale === "ja") return ja_custom_hex_code(inputs)
	if (locale === "zh") return zh_custom_hex_code(inputs)
	if (locale === "ar") return ar_custom_hex_code(inputs)
	if (locale === "id") return id_custom_hex_code(inputs)
	if (locale === "it") return it_custom_hex_code(inputs)
	if (locale === "ru") return ru_custom_hex_code(inputs)
	if (locale === "pt") return pt_custom_hex_code(inputs)
	return ko_custom_hex_code(inputs)
});